/**
 * tRPC Client Configuration
 *
 * This file sets up the tRPC client for use in React components.
 * The client calls vectorsellapi directly from the browser (no proxy).
 * See: https://trpc.io/docs/client/react
 */

import { createTRPCReact } from '@trpc/react-query'
import { httpBatchLink } from '@trpc/client'
import { config } from '../config'

// Import AppRouter type from vectorsellapi
// This provides full type safety for tRPC calls
import type { AppRouter } from '../../../../vectorsellapi/src/trpc/routers/_app.js'

/**
 * Create a tRPC React client
 * This provides hooks like trpc.quotation.generate.useMutation()
 */
export const trpc = createTRPCReact<AppRouter>()

/**
 * Get the vectorsellapi URL
 * Browser calls vectorsellapi directly (no intermediate proxy)
 * Uses centralized config for runtime environment detection
 */
function getBaseUrl() {
  return config.getApiUrl()
}

/**
 * Create tRPC client instance
 * Use this in the TRPCProvider
 */
export function createTRPCClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${getBaseUrl()}/trpc`,
        // Optional: Add headers, credentials, etc.
        // headers() {
        //   return {
        //     authorization: getAuthToken(),
        //   }
        // },
      }),
    ],
  })
}
